export const formatNumber = (amount, round = 2) =>
  (amount ?? '').toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: round,
  }) || 0;
